module.exports = __webpack_public_path__ + "static/Stage2Back-ebc58bc705d7d576969ad1c4b9bc406e.png";